import { GRADING } from '../constants/config'

export function scoreObjective(q, answer) {
  if (q.type === 'msq') return scoreMsqCredit(answer, q.correct_answers, Object.keys(q.options ?? {}).length) === 1
  return q.correct_answer.toLowerCase() === answer.toLowerCase()
}

// Per AI team handoff: full credit for an exact match, partial credit for a
// correct-only subset — proportional to (correct picked ÷ total options in the
// question, not total correct options), zero for any wrong pick, no negative
// marking. Matches the server-side formula in aiService.js's scoreMsq.
export function scoreMsqCredit(answer, correctAnswers, totalOptions) {
  const chosen  = new Set(Array.isArray(answer) ? answer : [])
  const correct = new Set(correctAnswers ?? [])
  if (chosen.size === 0) return 0
  const wrongPicked = [...chosen].some(k => !correct.has(k))
  if (wrongPicked) return 0
  if (chosen.size === correct.size) return 1
  return chosen.size / (totalOptions || correct.size)
}

export function gradeShortAnswer(answer) {
  const words = answer.trim().split(/\s+/).filter(Boolean).length
  if (words < GRADING.SHORT_ANSWER_PARTIAL_WORDS)
    return { verdict: 'Incorrect',         feedback: 'Answer is too brief. Please provide more detail.' }
  if (words < GRADING.SHORT_ANSWER_CORRECT_WORDS)
    return { verdict: 'Partially Correct', feedback: 'You touched on the right idea but missed some key points.' }
  return   { verdict: 'Correct',           feedback: 'Good answer! You covered the main concepts accurately.' }
}

export function gradeLabel(pct) {
  if (pct >= 80)                      return 'Excellent'
  if (pct >= GRADING.PASS_CUTOFF_PCT) return 'Good'
  if (pct >= 35)                      return 'Needs Work'
  return                                     'Needs Significant Review'
}
